import { jsx } from "react/jsx-runtime";
import PropertyReportTransparency from "./PropertyReportTransparency.esm.js";
const PropertyReportTransparencyBlock = {
  Component: ({
    attrs
  }) => {
    const {
      id
    } = attrs;
    return /* @__PURE__ */ jsx(PropertyReportTransparency, { ...{
      id
    } });
  },
  metadata: {
    version: "1.0",
    name: "constellation/property-report-transparency",
    title: "Property Report Transparency Component",
    description: "Property Report Transparency Component",
    icon: "search",
    keywords: ["property", "report", "transparency"],
    supports: {
      customClassName: false,
      html: false
    },
    category: "Forms",
    attributes: {
      id: {
        type: "string"
      }
    }
  }
};
export {
  PropertyReportTransparencyBlock as default
};
